// Internals Imports
import { AUTH } from "../../constants";

// Destructuring
const { MOJITO, HURRICANE, PRODUCTION, DOMAIN_NAME } = AUTH;

export const addShowFieldToAddresses = settings => {
  const addressArray = [...settings.addresses];
  return {
    ...settings,
    addresses: addressArray.map(address => ({
      ...address,
      show: true,
    })),
  };
};

export const fooSettingsMethods = () => {
  console.debug("foo");
  // just a dummy function to avoid eslint default export issue
};

export const getIntegrationSubDomainCallbackUrl = (location, subDomain) => {
  const envName = process.env.REACT_APP_ENVIRONMENT;
  const { pathname, search } = location;
  if (envName === HURRICANE || envName === PRODUCTION || envName === MOJITO) {
    return `https://${subDomain}.${DOMAIN_NAME[envName]}${pathname}${search}`;
  }
  return "";
};



// WEBPACK FOOTER //
// ./src/actions/SettingsActions/settingsMethods.js